@if (secret | async) {
  <app-calendar [options]="options" [dayOnly]="true"></app-calendar>
} @else {
  <div class="wrapper">
    <div class="w-full h-full p-8 flex flex-col justify-center items-center">
      <div class="flex flex-col gap-4 w-128">
        <h1>Login</h1>

        <div class="flex flex-col gap-2">
          <label class="text-sm font-bold" for="secret">Secret</label>
          <input
            class="block rounded-md w-full border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:text-sm sm:leading-6"
            id="secret"
            type="text"
            [(ngModel)]="secretInput"
          />
        </div>

        <button
          class="rounded-md bg-primary-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-800"
          (click)="login()"
        >
          Login
        </button>
      </div>
    </div>
  </div>
}
